import { route, tag, type PageTour } from '../pageTour';

export const siteWallPlaybackTour: PageTour = {
  id: 'page-site-wall-playback',
  version: 1,
  title: 'Live Wall – Recorded',
  summary: 'Play back several cameras together on one timeline.',
  match: route('/live-wall/playback'),
  steps: [
    {
      target: tag('wall-mode-toggle'),
      title: 'Back to live',
      description: 'Switch the wall back to live video at any time.',
      side: 'bottom',
    },
    {
      target: tag('wall-playback-layout'),
      title: 'Wall layout',
      description: 'Change how many windows the wall has, even out their sizes, or clear every camera off the wall.',
      side: 'bottom',
    },
    {
      target: tag('playback-camera-panel'),
      title: 'Cameras',
      description: 'Drag a camera onto a window, or click it to add it to the next free one. Up to six cameras play together.',
      side: 'right',
    },
    {
      target: tag('wall-playback-grid'),
      title: 'The wall',
      description: 'Every camera here plays the same moment, so you can follow something across several views.',
      side: 'left',
    },
    {
      target: tag('playback-timeline'),
      title: 'Timeline',
      description: 'Pick the date and time range, then play, skip or change speed. Click the timeline to jump to a moment.',
      side: 'top',
    },
  ],
};
